import type { AgentWorkingStateFact, AgentWorkingStateValue } from "@/api/client/hosted-agents"

/**
 * Working-state display helpers (#3023). Kept outside the component files so
 * they satisfy `react-refresh/only-export-components` and can be shared by the
 * user section and the admin panel.
 */

/** Only facts with a CONFIRMED value are shown to users. */
export function activeWorkingStateFacts(facts: AgentWorkingStateFact[]): AgentWorkingStateFact[] {
  return facts.filter((fact) => fact.active !== null)
}

/** Human-readable rendering of a typed value plus its optional unit. */
export function formatWorkingStateValue(
  active: AgentWorkingStateValue,
  locale: string | undefined
): string {
  const { value, value_type: valueType, unit } = active
  let text: string
  if (valueType === "number" && typeof value === "number") {
    text = new Intl.NumberFormat(locale).format(value)
  } else if (valueType === "boolean") {
    text = value ? "true" : "false"
  } else if (valueType === "json") {
    text = JSON.stringify(value)
  } else {
    text = String(value ?? "")
  }
  return unit ? `${text} ${unit}` : text
}

/** The fact's display name: the admin-set label when present, otherwise the key. */
export function workingStateFactLabel(fact: AgentWorkingStateFact): string {
  return fact.label?.trim() || fact.key
}
